import { Component, OnInit, Renderer2, Inject } from '@angular/core';

@Component({
  selector: 'app-service-unavailable',
  templateUrl: './service-unavailable.component.html',
  styleUrls: ['../error.component.scss']
})
export class serviceUnavailableComponent implements OnInit {

  constructor() {
  }

  ngOnInit() {

  }
}
